import type { FC, ReactNode } from 'react'

import dynamic from 'next/dynamic'
import BootScreen from '@/components/game/boot-screen'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'

const GameRoot = dynamic(() => import('@/components/game/game-root'), {
    ssr: false,
    loading: () => <BootScreen />
})

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <h1 className='sr-only'>
                Phonics Grand Prix: CVC Race
            </h1>

            <GameRoot />
        </Layout>
    )
}

export default Home
